import { marked } from 'marked';

const renderer = new marked.Renderer();
const linkRenderer = renderer.link;
/**
 *  Added target blank markdown link handler as it is not out of box supported by marked js
 *  Ref: https://github.com/markedjs/marked/issues/655#issuecomment-712380889
 * */
renderer.link = (href, title, text) => {
  const html = linkRenderer.call(renderer, href, title, text);
  return html.replace(/^<a /, '<a target="_blank" rel="nofollow" ');
};

marked.setOptions({
  renderer,
});

export default marked;
